import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { RestrictedArea } from "@scenes/restrictedArea";

import { Props } from "./types";
import { SynthesisIcon } from "./synthesisIcon";
import { TimeSheetIcon } from "./timeSheetIcon";
import styles from "./styles.scss";

function Navigation({}: Props) {
  const { t } = useTranslation();

  return (
    <RestrictedArea areas={["personalTimesheet", "personalSynthesis"]}>
      {({ canAccessPersonalTimesheet, canAccessPersonalSynthesis }) => (
        <ul className={styles.navigation}>
          {canAccessPersonalSynthesis && (
            <li className={styles.item}>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  classNames(styles.link, { [styles.selectedLink]: isActive })
                }
              >
                <SynthesisIcon className={styles.icon} />
                <p className={styles.text}>
                  {t("personalSynthesis.navigation.synthesis")}
                </p>
              </NavLink>
            </li>
          )}
          {canAccessPersonalTimesheet && (
            <li className={styles.item}>
              <NavLink
                to="/time-sheets"
                className={({ isActive }) =>
                  classNames(styles.link, styles.timeSheets, {
                    [styles.selectedLink]: isActive,
                  })
                }
              >
                <TimeSheetIcon className={styles.icon} />
                <p className={styles.text}>
                  {t("personalSynthesis.navigation.timeSheets")}
                </p>
              </NavLink>
            </li>
          )}
        </ul>
      )}
    </RestrictedArea>
  );
}

export { Navigation };
